import { produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE,
  DOCUMENT_SETUP_CLEAR_ALL_STATE,
  DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_CHANGE,
  DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTED,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import { RequesterTextField as ContractSetupRequesterTextField } from '@app/store/contract-setup/RequesterField';
import RequesterFieldType from '@app/store/contract-setup/RequesterFieldType';
import { DocumentSetupAction } from '@app/store/documentSetup/actions';
import RequesterTextField from '@app/store/documentSetup/RequesterTextField';

export type DocumentSetupLastRequesterTextFieldState = RequesterTextField | null;

const initialState: DocumentSetupLastRequesterTextFieldState = null;

export default function reducer(
  state: DocumentSetupLastRequesterTextFieldState = initialState,
  action: DocumentSetupAction | ContractSetupAction
): DocumentSetupLastRequesterTextFieldState {
  switch (action.type) {
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
    case DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE:
    case DOCUMENT_SETUP_CLEAR_ALL_STATE:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
      const { requesterFields } = action.payload;

      const requesterTextField = requesterFields.find(
        (requesterField): requesterField is ContractSetupRequesterTextField =>
          requesterField.inputType === RequesterFieldType.TEXT_FIELD
      );

      if (requesterTextField) {
        const {
          dataLabel,
          id,
          positionX,
          positionY,
          positionZ,
          positionPage,
          sizeHeight,
          sizeWidth,
          textInputContent,
          textStyleAlign,
          textStyleFontSize,
          textStyleFontType,
        } = requesterTextField;
        return {
          id,
          pageNumber: positionPage,
          type: 'text',
          values: {
            dataLabel,
            fontFamily: textStyleFontType,
            fontSize: textStyleFontSize,
            height: sizeHeight,
            text: textInputContent,
            textAlign: textStyleAlign,
            width: sizeWidth,
            x: positionX,
            y: positionY,
            z: positionZ,
          },
        };
      }
      return null;
    }
    case DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_CHANGE:
      return produce(state, (draft) => {
        const { id, values } = action.payload;
        if (draft?.id === id) {
          draft.values = values;
        }
      });
    case DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTED:
      return action.payload;
    default:
      return state;
  }
}
